module.exports = __webpack_public_path__ + "static/server-eb5a8b8cd57ed9aea690396ce0416c05.png";